import React, { useCallback, useEffect, useState } from "react";
import { FaChevronLeft, FaChevronRight, FaXmark, FaPlus } from "react-icons/fa6";
import Reveal from "./Reveal";
import img1 from "../assets/images/1.jpeg";
import img3 from "../assets/images/3.jpeg";
import img4 from "../assets/images/4.jpeg";
import img5 from "../assets/images/5.jpeg";
import img8 from "../assets/images/8.jpeg";
import img10 from "../assets/images/10.jpeg";
import img13 from "../assets/images/13.jpeg";
import img15 from "../assets/images/15.jpeg";

const projects = [
  { src: img15, alt: "Pivote central instalado en un campo al pie de la sierra", caption: "Pivote central — San Luis" },
  { src: img1, alt: "Pivote central regando un lote de alfalfa al pie de la sierra", caption: "Pivote central — alfalfa" },
  { src: img3, alt: "Cañón de riego por aspersión montado sobre línea de conducción", caption: "Equipo de aspersión" },
  { src: img4, alt: "Aspersor regando el parque de una casa de campo", caption: "Riego de parque" },
  { src: img5, alt: "Aspersores regando un parque arbolado al atardecer", caption: "Espacio verde automatizado" },
  { src: img10, alt: "Aspersores regando un predio con invernaderos", caption: "Predio con invernaderos" },
  { src: img8, alt: "Perforación en funcionamiento con salida de agua a pleno caudal", caption: "Perforación y bombeo" },
  { src: img13, alt: "Aspersor emergente regando césped", caption: "Aspersor emergente" },
];

const Gallery = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const isOpen = activeIndex !== null;

  const close = useCallback(() => setActiveIndex(null), []);
  const next = useCallback(
    () => setActiveIndex((i) => (i + 1) % projects.length),
    []
  );
  const prev = useCallback(
    () => setActiveIndex((i) => (i - 1 + projects.length) % projects.length),
    []
  );

  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") close();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [isOpen, close, next, prev]);

  return (
    <section id="proyectos" className="bg-slate-50 py-20 sm:py-28">
      <div className="container-site">
        <Reveal className="mx-auto max-w-2xl text-center">
          <p className="section-eyebrow">Nuestro trabajo</p>
          <h2 className="section-title">Proyectos realizados</h2>
          <p className="section-lead">
            Instalaciones propias en campos, parques y predios deportivos de la
            región. Tocá una foto para verla en grande.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
          {projects.map((project, i) => (
            <Reveal key={project.src} delay={(i % 4) * 60}>
              <button
                type="button"
                onClick={() => setActiveIndex(i)}
                aria-label={`Ampliar foto: ${project.caption}`}
                className="group relative block w-full overflow-hidden rounded-xl bg-slate-200 shadow-card transition-shadow hover:shadow-card-hover"
              >
                <img
                  src={project.src}
                  alt={project.alt}
                  loading="lazy"
                  decoding="async"
                  className="aspect-[4/3] w-full object-cover transition-transform duration-500 ease-out group-hover:scale-110"
                />
                <span
                  className="absolute inset-0 flex items-center justify-center bg-campo-950/0 transition-colors duration-300 group-hover:bg-campo-950/45"
                  aria-hidden="true"
                >
                  <FaPlus
                    size={22}
                    className="scale-50 text-white opacity-0 transition-all duration-300 group-hover:scale-100 group-hover:opacity-100"
                  />
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {isOpen && (
        <div
          role="dialog"
          aria-modal="true"
          aria-label={projects[activeIndex].caption}
          className="fixed inset-0 z-[60] flex animate-fade-in items-center justify-center bg-campo-950/95 p-4 backdrop-blur-sm"
          onClick={close}
        >
          <button
            type="button"
            onClick={close}
            aria-label="Cerrar"
            className="absolute right-4 top-4 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/25"
          >
            <FaXmark size={20} aria-hidden="true" />
          </button>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              prev();
            }}
            aria-label="Foto anterior"
            className="absolute left-3 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/25 sm:left-6"
          >
            <FaChevronLeft size={18} aria-hidden="true" />
          </button>

          <figure
            className="max-h-full max-w-4xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={projects[activeIndex].src}
              alt={projects[activeIndex].alt}
              className="mx-auto max-h-[78vh] w-auto rounded-lg object-contain shadow-2xl"
            />
            <figcaption className="mt-4 text-center text-sm text-campo-100">
              {projects[activeIndex].caption}
              <span className="ml-2 text-campo-400">
                {activeIndex + 1} / {projects.length}
              </span>
            </figcaption>
          </figure>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              next();
            }}
            aria-label="Foto siguiente"
            className="absolute right-3 flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/25 sm:right-6"
          >
            <FaChevronRight size={18} aria-hidden="true" />
          </button>
        </div>
      )}
    </section>
  );
};

export default Gallery;
